import FeaturedItem from './FeaturedItem';

export { type FeaturedItemProps } from './FeaturedItem';
export default FeaturedItem;
